const THUMBNAIL_FILE_TYPES = [
	'jpg',
	'jpeg',
	'png',
	'webp',
	'gif',
	'svg',
	'bmp',
	'tiff',
	'pdf',
	'mp4',
	'mov',
];

const PREVIEW_FILE_TYPES = [...THUMBNAIL_FILE_TYPES, 'xls', 'xlsx'];

export const FALLBACK_THUMBNAIL =
	'https://placehold.co/1280x720/000000/D9D9D9/jpeg?text=No+Thumbnail%0APreview+Available&font=Inter';

export const FILE_SIZE_SUFFIXES = [
	'Bytes',
	'KB',
	'MB',
	'GB',
	'TB',
	'PB',
	'EB',
	'ZB',
	'YB',
];

export const isThumbnailFile = (type) =>
	THUMBNAIL_FILE_TYPES.includes(type ? type.toLowerCase() : '');

export const isPreviewFile = (type) =>
	PREVIEW_FILE_TYPES.includes(type ? type.toLowerCase() : '');

export const getFileColumnDataType = (type) => {
	try {
		if (type) {
			return type.trim().toUpperCase();
		}
		return 'File';
	} catch (error) {
		console.log('error', error);
		return '';
	}
};

// DEPRECATED: Use getBytes instead
export const formatBytes = (kiloBytes, decimal = 2) => {
	let val = `${parseFloat(kiloBytes)} KB`;
	if (kiloBytes > 1000) {
		val = `${(parseFloat(kiloBytes) / 1000).toFixed(decimal)} MB`;
	}
	return val;
};

export const getBytes = (b) => {
	if (b === 0 || !b || b === undefined || b === null) return '0 Bytes';

	let u = 0;
	const s = 1024;
	while (b >= s || -b >= s) {
		b /= s;
		u++;
	}
	return `${(u ? `${b.toFixed(1)} ` : b) + ' KMGTPEZY'[u]}B`;
};

export const millisToMinutesAndSeconds = (millis) => {
	const d = new Date(Date.UTC(0, 0, 0, 0, 0, 0, millis));
	// Pull out parts of interest
	const parts = [
		// d.getUTCHours(),
		d.getUTCMinutes(),
		d.getUTCSeconds(),
	];
	// Zero-pad
	const formatted = parts.map((s) => String(s).padStart(2, '0')).join(':');
	return formatted;
};

async function toDataURL(url) {
	const blob = await fetch(url).then((res) => res.blob());
	return URL.createObjectURL(blob);
}

// DEPRECATED: CBAY related
// NOT DRY
export const downloadURI = async (uri, name) => {
	const a = document.createElement('a');
	a.href = await toDataURL(uri);
	a.download = name;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};

// DEPRECATED: CBAY related
export const getActiveSubPath = (currentPath, rootPath) => {
	let subPath = currentPath ? `/${currentPath}` : '';
	if (rootPath) {
		subPath = `${rootPath}${subPath}`;
	}
	return subPath;
};
